import ProfitAndLoss from "../../components/Dashboard/ProfitAndLoss";
import Banking from "../../components/Dashboard/Banking";
import Debts from "../../components/Dashboard/Debts";
import BarChartComponent from "../../components/Dashboard/BarChartComponent";
import Checkouts from "../../components/Dashboard/Checkouts";
import Creditors from "components/Dashboard/Creditors";
import RecieveCheques from "components/Dashboard/RecieveCheques";
import PaymentCheques from "components/Dashboard/PaymentCheques";
import Documents from "components/Dashboard/Documents";
import TopBuys from "components/Dashboard/TopBuys";
import TopSales from "components/Dashboard/TopSales";
import SalesChart from "components/Dashboard/SalesChart";
import BuysChart from "components/Dashboard/BuysChart";

export const widgets = [
  {
    title: "نمودار درآمد و هزینه",
    Component: BarChartComponent,
    imagePath: "/assets/images/widgets/barchart.png",
    apiPath: "/dashboard/latestAccountings",
    col: { xs: 12, sm: 12, md: 7, lg:7, xl: 7 },
  },
  {
    title: "سود و زیان",
    Component: ProfitAndLoss,
    imagePath: "/assets/images/widgets/labeled_barchart.png",
    apiPath: "/dashboard/profitAndLoss",
    col: { xs: 12, sm: 12, md: 5, lg: 5, xl: 5 },
  },
  {
    title: "حساب ها",
    Component: Banking,
    imagePath: "/assets/images/widgets/cheque.png", //TODO: new design needs to be added
    apiPath: "/dashboard/banking",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "بدهکاران",
    Component: Debts,
    imagePath: "/assets/images/widgets/cheque.png", //TODO: new design needs to be added
    apiPath: "/dashboard/debtors",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "بستانکاران",
    Component: Creditors,
    imagePath: "/assets/images/widgets/cheque.png", //TODO: new design needs to be added
    apiPath: "/dashboard/creditors",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "فاکتور ها",
    Component: Checkouts,
    imagePath: "/assets/images/widgets/invoices.png",
    apiPath: "/dashboard/salesFactor",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "چک های پرداختی",
    Component: PaymentCheques,
    imagePath: "/assets/images/widgets/cheque.png",
    apiPath: "/dashboard/paymentCheque",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "چک های دریافتی",
    Component: RecieveCheques,
    imagePath: "/assets/images/widgets/cheque.png",
    apiPath: "/dashboard/receiveCheque",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },

  {
    title: "آخرین اسناد",
    Component: Documents,
    imagePath: "/assets/images/widgets/cheque.png",
    apiPath: "/dashboard/salesChart",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "بیشترین فروش",
    Component: TopSales,
    imagePath: "/assets/images/widgets/pie_chart.png",
    apiPath: "/dashboard/topSales",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "بیشترین خرید",
    Component: TopBuys,
    imagePath: "/assets/images/widgets/pie_chart.png",
    apiPath: "/dashboard/topBuys",
    col: { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 },
  },
  {
    title: "نمودار فروش",
    Component: SalesChart,
    imagePath: "/assets/images/widgets/linear_chart.png",
    apiPath: "/dashboard/salesChart",
    col: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
  },
  {
    title: "نمودار خرید",
    Component: BuysChart,
    imagePath: "/assets/images/widgets/linear_chart.png",
    apiPath: "/dashboard/buysChart",
    col: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
  },
];

export const options = [
  { label: "کل سال مالی", value: "" },
  { label: "فصلی", value: "فصلی" },
  { label: "ماهانه", value: "ماهانه" },
  { label: "هفتگی", value: "هفتگی" },
  { label: "روزانه", value: "روزانه" },
];

export default widgets;
